import { useState } from 'react';
import { useAppContext } from 'src/app/state';
import { ActionType } from 'src/app/state/action-type.enum';
import Button from '../button/Button';
import { TimeOptions } from 'src/types/date-time.types';
import { getCurrentTime } from 'src/app/utils/date-time.utils';
import TimeSelector from '../time-selector/TimeSelector';

type TimePopupContentProps = {
  selectedTime?: TimeOptions;
  handleSelectTime: (time: TimeOptions) => void;
};

const TimePopupContent = ({
  selectedTime,
  handleSelectTime,
}: TimePopupContentProps) => {
  const { dispatch } = useAppContext();
  const [time, setTime] = useState(selectedTime ?? getCurrentTime());
  const handleTimeChange = (selection: TimeOptions) => {
    setTime(selection);
  };
  const handleClockClose = () => {
    handleSelectTime(time);
    dispatch({ type: ActionType.POP_UP_CLOSE, payload: {} });
  };
  return (
    <>
      <TimeSelector
        hours={time.hours}
        minutes={time.minutes}
        period={time.period}
        onTimeChange={handleTimeChange}
      />
      <Button
        type='primary'
        width='full-width'
        style={{ marginTop: '32px', width: '100%', marginLeft: 0 }}
        onClick={handleClockClose}
      >
        Confirm
      </Button>
    </>
  );
};

export default TimePopupContent;
